import { useTranslation } from 'react-i18next';
import { testimonials } from '@/mocks/data';

export default function TestimonialsSection() {
  const { t } = useTranslation();

  return (
    <section className="py-10 md:py-14">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-900 text-center mb-8">{t('testimonials.title')}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((item, index) => (
            <div key={index} className="p-5 rounded-lg bg-background-100 border border-background-200/70 animate-scale-in" style={{ animationDelay: `${index * 0.08}s` }}>
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className={`text-sm ${i < item.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}></i>
                  </div>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">{item.content}</p>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-sm font-heading text-primary-600">{item.name[0]}</span>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-800">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}